import type { TFunction } from 'i18next';
import { getVersion } from '../ConfigurationReader.ts';

const formatVersion = (
  backendVersion: string | undefined,
  t: TFunction<'translation', undefined>
) => {
  if (!backendVersion) {
    return `${t('ui.versionString')} ${getVersion()}`;
  }

  return `${t('ui.versionString')} ${getVersion()}${t('ui.versionDelimiter')}${backendVersion}`;
};

export { formatVersion };
